import gql from "graphql-tag";

export const DETECT_DOCUMENT_ANCHORS = gql`
  mutation DetectDocumentAnchors($file: DocumentTemplateFileInput!) {
    detectDocumentAnchors(file: $file)
  }
`;

export const CREATE_DOCUMENT_TEMPLATE = gql`
  mutation AddDocumentTemplate($data: DocumentTemplateDataInput) {
    addDocumentTemplate(data: $data) {
      id
      name
      anchors
      anchorMappings
    }
  }
`;

export const UPDATE_DOCUMENT_TEMPLATE = gql`
  mutation UpdateDocumentTemplate(
    $where: DocumentTemplateWhereInput
    $data: DocumentTemplateDataInput
  ) {
    updateDocumentTemplate(where: $where, data: $data) {
      id
      name
      anchors
      anchorMappings
      status
    }
  }
`;

export const DELETE_DOCUMENT_TEMPLATE = gql`
  mutation DeleteDocumentTemplate($where: DocumentTemplateWhereInput) {
    deleteDocumentTemplate(where: $where) {
      id
    }
  }
`;

export const PREVIEW_DOCUMENT_TEMPLATE = gql`
  mutation PreviewDocumentTemplate(
    $where: DocumentTemplateWhereInput!
    $mappings: JSONObject
    $payload: JSONObject!
  ) {
    previewDocumentTemplate(
      where: $where
      mappings: $mappings
      payload: $payload
    ) {
      base64
      unresolved
    }
  }
`;

const documentTemplates = {
  CREATE_DOCUMENT_TEMPLATE,
  UPDATE_DOCUMENT_TEMPLATE,
  DELETE_DOCUMENT_TEMPLATE,
  DETECT_DOCUMENT_ANCHORS,
  PREVIEW_DOCUMENT_TEMPLATE,
};

export default documentTemplates;
